import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {
    DialogModule,
    DropdownModule,
    FileUploadModule,
    InputTextModule,
    RadioButtonModule,
    TooltipModule
} from 'primeng/primeng';
import {KeyFilterModule} from 'primeng/keyfilter';

import {sitesRouting} from './sites.routing'
import {SiteListComponent} from './site-list.component';
import {SiteFormComponent} from './site-form.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        FileUploadModule,
        InputTextModule,
        RadioButtonModule,
        DropdownModule,
        TooltipModule,
        DialogModule,
        KeyFilterModule,
        sitesRouting
    ],
    declarations: [
        SiteListComponent,
        SiteFormComponent
    ]
})

export class SitesModule {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/sites/sites.module.ts